import { get } from 'api/Api';
import checkResponse from 'services/api/checkResponse';
import { ReleaseJson } from './dto';
import { releaseJsonExample } from './examples';

const getRelease = async () =>
	get<ReleaseJson>('v1/release').then(checkResponse(releaseJsonExample));

export { getRelease };
